import React, { useState, useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";
import store from "../../store";
import Button from "@material-ui/core/Button";
import config from "../../config";
import Grid from "@material-ui/core/Grid";
import color from "../../assets/jss/color";
import withStyles from "@material-ui/core/styles/withStyles";

import { trackPage } from "../../analytics";

const withSignupEventCode = (path, signupEventCode) =>
  signupEventCode
    ? `${path}?signupEventCode=${encodeURIComponent(signupEventCode)}`
    : path;

function isMobile() {
  var check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

const GetPosition = props => {
  useEffect(() => {
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    function success(pos) {
      var crd = pos.coords;
      props.responded(crd.latitude, crd.longitude);
    }

    function error(err) {
      props.responded();
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  }, []);

  return null;
};

const styles = {
  title: {
    textAlign: "center",
    paddingLeft: "5px"
  },
  subtitle: {
    textAlign: "center",
    paddingLeft: "5px"
  },
  question: {
    textAlign: "center",
    paddingLeft: "5px"
  },
  choicebutton: {
    textAlign: "center",
    margin: "10px"
  },
  blankspace: {
    height: "4vh"
  },

  blankspace2: {
    height: "1vh"
  },
  consent: {
    background: color.mcslightblue,
    height: "80px",
    color: "white",
    "&:hover": {
      opacity: 0.8
    }
  },
  skip: {
    background: "grey",
    height: "80px",
    color: "white",
    "&:hover": {
      opacity: 0.8
    }
  }
};
const AutoLocation = props => {
  const { classes } = props;
  const [advertising, setAdvertising] = useState(true);
  const [respondedToPopup, setRespondedToPopup] = useState(false);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    trackPage("autolocation");
  }, []);

  const ss = store.getState();
  if (ss.data.signupclass === "") {
    return (
      <Redirect
        to={withSignupEventCode(
          config.SIGNUP.APP_PATH + "/",
          props.signupEventCode
        )}
      />
    );
  }

  const validCoordinates = (coord1, coord2) => {
    const coordRegex = /^-?\d{0,5}\.?\d{0,30}$/;
    if (coordRegex.test(coord1) && coordRegex.test(coord2)) {
      return true;
    } else {
      return false;
    }
  };

  if (!isMobile()) {
    return (
      <Redirect
        to={withSignupEventCode(
          config.SIGNUP.APP_PATH + "/form",
          props.signupEventCode
        )}
      />
    );
  }

  if (advertising) {
    return (
      <Grid container justify="center">
        <Grid item xs={12} md={6} className={classes.title}>
          <p>We've detected you are on a mobile device. </p>
          <p>
            If you are currently at the{" "}
            <b>location you want to get internet services</b> you may give us
            permission to use the GPS coordinates from your phone and simplify
            the signup process
          </p>
          <Grid item xs={12}>
            <Grid container justify="center">
              <Grid item xs={12} sm={5} className={classes.choicebutton}>
                <Button
                  onClick={() => setAdvertising(false)}
                  fullWidth
                  className={classes.consent}
                >
                  <h3>Use my position from GPS</h3>
                </Button>
              </Grid>
              <Grid item xs={12} sm={5} className={classes.choicebutton}>
                <Button
                  onClick={() => {
                    props.history.push(
                      withSignupEventCode(
                        config.SIGNUP.APP_PATH + "/form",
                        props.signupEventCode
                      )
                    );
                  }}
                  fullWidth
                  className={classes.skip}
                >
                  <h3>Skip step</h3>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
  return (
    <Grid container justify="center">
      <Grid item xs={12} className={classes.title}>
        <GetPosition
          responded={(latitude, longitude) => {
            setLat(latitude);
            setLng(longitude);
            setRespondedToPopup(true);
          }}
        />
      </Grid>
      {respondedToPopup ? (
        <Grid key="responded" item xs={12}>
          {validCoordinates(lat, lng) ? (
            <Grid container justify="center">
              <Grid item xs={12} className={classes.choicebutton}>
                <iframe
                  title="google-maps"
                  width="300"
                  height="350"
                  style={{ border: "0" }}
                  src={
                    `https://www.google.com/maps/embed/v1/place?key=AIzaSyAqt4vdJQEPqlyZh4WYGoFOAt3BXIzow9o&center=${lat},${lng}&zoom=16&maptype=satellite&q=${lat}` +
                    "%2C%20" +
                    `${lng}`
                  }
                />
              </Grid>
              <Grid item xs={12} className={classes.choicebutton}>
                <p>
                  Is this the <b>location where you want internet</b> ?
                </p>
              </Grid>
              <Grid item xs={12} sm={5} className={classes.choicebutton}>
                <Button
                  onClick={() => {
                    if (lat != null && lng != null) {
                      props.setLat(lat);
                      props.setLng(lng);
                    }
                    props.history.push(
                      withSignupEventCode(
                        config.SIGNUP.APP_PATH + "/form",
                        props.signupEventCode
                      )
                    );
                  }}
                  fullWidth
                  className={classes.consent}
                >
                  <h3>Yes</h3>
                </Button>
              </Grid>
              <Grid item xs={12} sm={5} className={classes.choicebutton}>
                <Button
                  onClick={() =>
                    props.history.push(
                      withSignupEventCode(
                        config.SIGNUP.APP_PATH + "/form",
                        props.signupEventCode
                      )
                    )
                  }
                  fullWidth
                  className={classes.skip}
                >
                  <h3>No</h3>
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container justify="center">
              <Grid item xs={12} className={classes.choicebutton}>
                <p>
                  We were unable to retrieve your precise GPS coordinates. You
                  can continue the signup process without it.
                </p>
              </Grid>
              <Grid item xs={12} sm={5} className={classes.choicebutton}>
                <Button
                  onClick={() =>
                    props.history.push(
                      withSignupEventCode(
                        config.SIGNUP.APP_PATH + "/form",
                        props.signupEventCode
                      )
                    )
                  }
                  fullWidth
                  className={classes.consent}
                >
                  <h3>Continue</h3>
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid key="waiting" item xs={12} className={classes.choicebutton}>
          <p>Waiting for GPS signal...</p>
        </Grid>
      )}
    </Grid>
  );
};

export default withStyles(styles)(withRouter(AutoLocation));
